import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import Dropdown from '@/_core/shared/ui/Dropdown/Dropdown.vue';
import type { TDropdownItem } from '@/_core/shared/ui/Dropdown/Dropdown.vue';
import type { TFolder } from '@/_core/entities/report/models/types';
import type { TVulnerabilityFolder } from '@/_core/entities/vulnerability/models/types';
import { DEFAULT_FOLDER_NAMES } from '@/_core/entities/report/models/consts';
import FolderMoveIcon from '@/assets/images/svg/folder-move.svg?component';
import ChevronDownIcon from '@/assets/images/svg/chevron-down.svg?component';


export default /*#__PURE__*/_defineComponent({
  __name: 'FoldersDropdown',
  props: {
    folders: null,
    currentFolder: null,
    className: null
  },
  setup(__props: any, { emit }: { emit: ({
  (e: typeof EMIT_MOVE, folder: TFolder): void;
  (e: typeof EMIT_CREATE_FOLDER): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  folders: TFolder[];
  currentFolder: TVulnerabilityFolder | null;
  className?: string;
};

const EMIT_MOVE = 'move' as const;
const EMIT_CREATE_FOLDER = 'create-folder' as const;





const handleCreateFolder = () => emit(EMIT_CREATE_FOLDER);
const handleMove = (folder: TFolder) => emit(EMIT_MOVE, folder);

const STATIC_CREATE_FOLDER_ITEM: TDropdownItem = {
  label: 'Create folder',
  action: handleCreateFolder,
  className: 'tw:text-main-blue',
};

const items = computed<TDropdownItem[]>(() => [
  STATIC_CREATE_FOLDER_ITEM,
  ...props.folders
    .filter((folder) => folder.name !== DEFAULT_FOLDER_NAMES.allVulnerabilities) // virtual folder for all vulnerabilities, should not be included
    .map((folder) => ({
      label: folder.name,
      action: () => handleMove(folder),
    })),
]);

return { __sfc: true,EMIT_MOVE, EMIT_CREATE_FOLDER, props, emit, handleCreateFolder, handleMove, STATIC_CREATE_FOLDER_ITEM, items, Dropdown, FolderMoveIcon, ChevronDownIcon }
}

})